import { Store } from "lucide-react";

export interface SellerAttributionProps {
  productId: string;
  productUrl?: string | null;
  redirectUrl?: string | null;
  destinationUrl?: string | null;
  isRedirectLoading?: boolean;
  retailerName: string;
  sellerDisplayName?: string;
}

export function SellerAttribution({
  productId,
  productUrl,
  redirectUrl,
  destinationUrl,
  isRedirectLoading = false,
  retailerName,
  sellerDisplayName,
}: SellerAttributionProps) {
  if (!productUrl) return null;

  const visibleSellerName = sellerDisplayName || retailerName;

  const outboundUrl = redirectUrl || destinationUrl || "";
  if (isRedirectLoading || !outboundUrl) {
    return (
      <div className="flex items-center gap-3">
        <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-gray-100">
          <Store className="h-3 w-3 text-gray-600" />
        </div>
        <span className="text-sm text-gray-500">Sold by {visibleSellerName}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-gray-100">
        <Store className="h-3 w-3 text-gray-600" />
      </div>
      <a
        href={outboundUrl}
        target="_blank"
        rel="noopener noreferrer nofollow sponsored"
        className="text-sm text-gray-500 hover:underline"
      >
        Sold by {visibleSellerName}
      </a>
    </div>
  );
}
